import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import { usersAPI } from '../services/api';
import Loading from '../components/Loading';
import { useToast } from '../context/ToastContext';

const Users = () => {
  const toast = useToast();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    email: '',
    userType: 'master_iii',
    fullName: ''
  });

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      const response = await usersAPI.getAll();
      setUsers(response.data.users);
    } catch (error) {
      console.error('Error cargando usuarios:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await usersAPI.create(formData);
      setShowModal(false);
      setFormData({ username: '', password: '', email: '', userType: 'master_iii', fullName: '' });
      loadUsers();
    } catch (error) {
      toast.error(error.response?.data?.error || 'Error creando usuario');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este usuario?')) {
      try {
        await usersAPI.delete(id);
        loadUsers();
      } catch (error) {
        toast.error(error.response?.data?.error || 'Error eliminando usuario');
      }
    }
  };

  if (loading) return <Layout><Loading /></Layout>;

  return (
    <Layout>
      <div className="px-4 sm:px-0">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Usuarios</h1>
          <button onClick={() => setShowModal(true)} className="btn-primary">
            Nuevo Usuario
          </button>
        </div>

        <div className="bg-white shadow-md rounded-lg overflow-hidden">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Usuario</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Email</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Tipo</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Acciones</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {users.map((user) => (
                <tr key={user.id}>
                  <td className="px-6 py-4 whitespace-nowrap">{user.username}</td>
                  <td className="px-6 py-4 whitespace-nowrap">{user.email}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">
                      {user.userType.replace('_', ' ').toUpperCase()}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <button onClick={() => handleDelete(user.id)} className="text-red-600 hover:text-red-900">
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Modal */}
        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-8 max-w-md w-full">
              <h2 className="text-2xl font-bold mb-4">Nuevo Usuario</h2>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="label">Usuario</label>
                  <input type="text" className="input-field" value={formData.username}
                    onChange={(e) => setFormData({...formData, username: e.target.value})} required />
                </div>
                <div>
                  <label className="label">Contraseña</label>
                  <input type="password" className="input-field" value={formData.password}
                    onChange={(e) => setFormData({...formData, password: e.target.value})} required />
                </div>
                <div>
                  <label className="label">Email</label>
                  <input type="email" className="input-field" value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})} required />
                </div>
                <div>
                  <label className="label">Nombre Completo</label>
                  <input type="text" className="input-field" value={formData.fullName}
                    onChange={(e) => setFormData({...formData, fullName: e.target.value})} />
                </div>
                <div>
                  <label className="label">Tipo de Usuario</label>
                  <select className="input-field" value={formData.userType}
                    onChange={(e) => setFormData({...formData, userType: e.target.value})}>
                    <option value="master_i">Master I (Todo)</option>
                    <option value="master_ii">Master II (Formularios y Voces)</option>
                    <option value="master_iii">Master III (Solo Formularios)</option>
                  </select>
                </div>
                <div className="flex space-x-4">
                  <button type="submit" className="btn-primary flex-1">Crear</button>
                  <button type="button" onClick={() => setShowModal(false)} className="btn-secondary flex-1">Cancelar</button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Users;
